var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 16l1 1v5c-.003.667-.336 1-1 1C10 23 1 14 1 2c0-.667.333-1 1-1h5l1 1 1 5-2 2 8 8 2-2 5 1z","stroke":"currentColor","strokeWidth":"2","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

PhoneInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
